import RootState from '@/store/root_state';
import { ActionTree } from 'vuex';
import { FeatureFlagsState } from './state';
import { ChimeraMeResult, getChimeraFeatureFlags } from '@/store/graphql/queries/chimeraQueries';
import { query } from '@/helpers/chimera';

const actions: ActionTree<FeatureFlagsState, RootState> = {
  async GET_CHIMERA_FEATURE_FLAGS_INFO({ commit }): Promise<void> {
    const response = await query<ChimeraMeResult>(getChimeraFeatureFlags).catch(() => ({
      data: { chimera: { me: null } },
    }));

    const { me } = response.data.chimera;

    if (me) {
      commit(
        'ENROLLMENTS_UG_ENABLE_COUNTY_FIELD',
        me.featureFlags['enrollments-ug-enable-county-field'],
      );
    }
  },
};

export default actions;
